import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { AppService } from 'src/app/_service/app.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  user: any = { Id: "", Password: "" };
  passwordForm: FormGroup;

  constructor(
    public dialog: MatDialog,
    private appService: AppService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private locationn: Location
  ) {
    const data = JSON.parse(localStorage.getItem('office_q_uid') || '{}');
    this.user.Id = data.UserId;

    this.passwordForm = this.fb.group(
      {
        OldPassword: ['', Validators.required],
        NewPassword: ['', [Validators.required, Validators.minLength(8)]],
        ConfirmPassword: ['', Validators.required]
      },
      { validators: this.passwordMatchValidator }
    );
  }

  ngOnInit() {
    this.getCurrentUserPassword();
  }

  getCurrentUserPassword() {
    this.appService.postService({ ...this.user }, 'UserGetById')
      .subscribe(response => {
        this.user.Password = response.body.Result.Password;
      });
  }

  passwordMatchValidator(group: AbstractControl) {
    const newPassword = group.get('NewPassword').value;
    const confirmPassword = group.get('ConfirmPassword').value;
    return newPassword === confirmPassword ? null : { passwordMismatch: true };
  }

  changePassword() {
    if (this.passwordForm.invalid) return;

    const oldPass = this.passwordForm.get('OldPassword').value;
    const newPass = this.passwordForm.get('NewPassword').value;

    if (oldPass !== this.user.Password) {
      alert('Old password is incorrect');
      return;
    }

    this.user.Password = newPass;
    this.appService.postService({ ...this.user }, 'ChangePassword')
      .subscribe(response => {
        if (response.body.Success) {
          alert('Password changed successfully!');
          this.router.navigate(['/app/dashboard']);
        } else {
          alert('Failed to change password.');
        }
      });
  }

  goBack(): void {
    this.locationn.back();
  }
}
